import script from "./MeetingRoomReservation.vue?vue&type=script&setup=true&lang=js"
export * from "./MeetingRoomReservation.vue?vue&type=script&setup=true&lang=js"

import "./MeetingRoomReservation.vue?vue&type=style&index=0&id=5ccb7dda&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ccb7dda"]])

export default __exports__